import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BalanceSheetService } from '../../../service/account/balance-sheet.service';
import swal from 'sweetalert';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-enter-public-key',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './enter-public-key.component.html',
  styleUrl: './enter-public-key.component.scss',
})
export class EnterPublicKeyComponent {
  publicKey: string = '';
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<EnterPublicKeyComponent>,
    private balanceSheetService: BalanceSheetService,
  ) {}

  submit() {
    this.loading = true;

    this.balanceSheetService.loadPublicKey(this.publicKey).subscribe({
      next: async (res: any) => {
        this.loading = false;

        if (res?.success) {
          await Swal.fire({
            title: 'Success!',
            text: 'Public Key has been saved successfully.',
            icon: 'success',
            confirmButtonText: 'OK',
          });

          this.dialogRef.close(res);
        } else {
          Swal.fire({
            title: 'Error',
            text: res?.message || 'Something went wrong',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      },

      error: () => {
        this.loading = false;

        Swal.fire({
          title: 'Error',
          text: 'Failed to save public key',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      },
    });
  }

  close() {
    this.dialogRef.close();
  }
}
